<template src="./index.html">
</template>
<script>
import {getdata} from './data.js'

export default {
  name: '',
  components: {},
  data: function () {
    return {
      headData: getdata().headData,
      headDatavx: getdata().headDatavx,
      delCells: [],
      tableDatavx_3: [
        {
          label: "请选择",
          value: ""
        },
        {
          label: "正常",
          value: "01"
        },
        {
          label: "注销",
          value: "02"
        },
        {
          label: "正常转注销",
          value: "03"
        },
        {
          label: "其他原因不就地撤销",
          value: "09"
        },
      ],
      tableDatavx_8: [
        {
          label: "请选择",
          value: ""
        },
        {
          label: "西部大开发15%税率",
          value: "01"
        },
        {
          label: "海南自贸港15%税率",
          value: "02"
        },
        {
          label: "广东横琴、福建平潭、深圳前海等地15%税率",
          value: "03"
        },
      ]
    };
  },
  props: {
    toseeUpdate: {
      type: Boolean,
      default: false
    },
    showpz: {
      type: Boolean,
      default: false
    },
    tableDatavx: {
      type: Array,
      default: [],
    },
    tableData: {
      type: Array,
      default: [],
    },
    headobj: {
      type: Object,
      default: {},
    },
    choosecellCode: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
  },
  created() {
  },
  methods: {
    foraddhang(txaval, index) {
      let endobj = this.tableDatavx[this.tableDatavx.length - 1]
      this.tableDatavx.pop()
      this.tableDatavx.push({
        sdsA_3_x_1: {
          cellCode: "sdsA_3_" + (parseFloat(this.tableDatavx.length) + 1) + "_1",
          cellType: "0",
          cellVal: "",
          updateDesc: "",
          map: {}
        },
        sdsA_3_x_2: {
          cellCode: "sdsA_3_" + (parseFloat(this.tableDatavx.length) + 1) + "_2",
          cellType: "0",
          cellVal: "",
          updateDesc: "",
          map: {}
        },
        sdsA_3_x_3: {
          cellCode: "sdsA_3_" + (parseFloat(this.tableDatavx.length) + 1) + "_3",
          cellType: "0",
          cellVal: "",
          updateDesc: "",
          map: {}
        },
        sdsA_3_x_4: {
          cellCode: "sdsA_3_" + (parseFloat(this.tableDatavx.length) + 1) + "_4",
          cellType: "0",
          cellVal: "",
          updateDesc: "",
          map: {}
        },
        sdsA_3_x_5: {
          cellCode: "sdsA_3_" + (parseFloat(this.tableDatavx.length) + 1) + "_5",
          cellType: "0",
          cellVal: "",
          updateDesc: "",
          map: {}
        },
        sdsA_3_x_6: {
          cellCode: "sdsA_3_" + (parseFloat(this.tableDatavx.length) + 1) + "_6",
          cellType: "0",
          cellVal: "",
          updateDesc: "",
          map: {}
        },
        sdsA_3_x_7: {
          cellCode: "sdsA_3_" + (parseFloat(this.tableDatavx.length) + 1) + "_7",
          cellType: "0",
          cellVal: "",
          updateDesc: "",
          map: {}
        },
        sdsA_3_x_8: {
          cellCode: "sdsA_3_" + (parseFloat(this.tableDatavx.length) + 1) + "_8",
          cellType: "0",
          cellVal: "",
          updateDesc: "",
          map: {}
        },
        sdsA_3_x_9: {
          cellCode: "sdsA_3_" + (parseFloat(this.tableDatavx.length) + 1) + "_9",
          cellType: "0",
          cellVal: "",
          updateDesc: "",
          map: {}
        },
        sdsA_3_x_10: {
          cellCode: "sdsA_3_" + (parseFloat(this.tableDatavx.length) + 1) + "_10",
          cellType: "0",
          cellVal: "",
          updateDesc: "",
          map: {}
        }
      })
      this.tableDatavx.push(
          endobj
      )
    },
    fordelete(index) {
      if (this.$notemptyandnull(this.tableDatavx[index]['sdsA_3_x_1'].id)) {
        this.delCells.push(JSON.parse(JSON.stringify(this.tableDatavx[index])))
      }
      this.tableDatavx.splice(index, 1)
      this.$emit('delCellsCode', this.delCells)
    },
    spanmethod({
                 row,
                 column,
                 rowIndex,
                 columnIndex
               }) {
      if (columnIndex === 0) {
        if (rowIndex === 2) {
          return {
            rowspan: this.tableDatavx.length - 3,
            colspan: 1
          };
        } else if (rowIndex > 2) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      } else if (columnIndex === 1) {
        if (rowIndex === this.tableDatavx.length - 1) {
          return {
            rowspan: 1,
            colspan: 4
          };
        }
      } else if (columnIndex === 2) {
        if (rowIndex === this.tableDatavx.length - 1) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      else if (columnIndex === 3) {
        if (rowIndex === this.tableDatavx.length - 1) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    headercellstyle({
                      row,
                      column,
                      rowIndex,
                      columnIndex
                    }) {
      if (rowIndex === 0) {
        if (columnIndex === 8) {
          this.$nextTick(() => {
            if (document.getElementsByClassName(column.id).length !== 0) {
              document
                  .getElementsByClassName(column.id)[0]
                  .setAttribute('rowspan', 2);
            }
          });
        }
      }
    },
    inputblur(e) {
      this.$emit("inputblur", e)
    },
    zcsclick(e) {
      this.$emit("zcsclick", e)
    },
    forhover(table, colum, index) {
      this.$emit("forhover", table, colum, index)
    },
    forpz() {
      if (this.showpz) {
        this.$emit("forpz", "")
      }
    },

  }
};
</script>

<style scoped lang="less">
@import url('./index.less');
@import url('../../SmallScaleVAT/index.less');
</style>
